import React, { memo } from 'react'
import { useNavigate } from 'react-router-dom'

import BootstrapModalLayout from '../../ui/BootstrapModalLayout'
import { Pool } from '../../common/redux/api/web-api'
import { PoolDetailsWidget } from '../components/PoolDetailsWidget'
import useText from '../../common/hooks/useText'

export type AddEditPoolModal = {
    save: () => void
    cancel: () => void
    poolValue?: Pool
}

export const AddPoolModal = memo(function AddEditPoolModal({
    save,
    cancel,
    poolValue,
}: AddEditPoolModal): React.ReactElement {
    const text = useText()
    const navigate = useNavigate()
    return (
        <BootstrapModalLayout
            title={poolValue ? text('lblPoolModal', { name: poolValue.name }) : text('lblNewPoolModal')}
            size={'md'}
        >
            <PoolDetailsWidget
                cancel={cancel}
                save={save}
                poolValue={poolValue}
                locationCheck={() => {
                    navigate('/pools')
                }}
            />
        </BootstrapModalLayout>
    )
})
